import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Port } from "src/app/domain/models/Port";
import { Routes } from "src/app/infrastructure/routes";
import { AirportGateway } from "../gateway/AirportGateway";
import { Airport, NewAirport } from "src/app/domain/models/Airport";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export class AirportService extends AirportGateway {

    constructor(private _http: HttpClient){
        super()
    }

    getAll(): Observable<Airport[]> {
        return this._http.get<Port[]>(Routes.airportApi + '/GetAll')
      }

    getOriginAirports(): Observable<Port[]> {
      return this._http.get<Airport[]>(Routes.airportApi + '/GetOriginAirports')
    }

    getDestinationAirportsByCountry(countryId: number): Observable<Port[]> {
      return this._http.get<Airport[]>(Routes.airportApi + '/GetDestinationAirportsByCountry', {params: {countryId}})
    }

    create(airport: NewAirport): Observable<Airport> {
      return this._http.post<Airport>(Routes.airportApi + '/Create', airport)
    }

    getAllPaged(pageNumber: number = 1, pageSize: number= 10): Observable<PageResult<Airport>> {
      return this._http.get<PageResult<Airport>>(Routes.airportApi + '/GetAllPaginated', {params: {pageNumber, pageSize}})
    }
}
